// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Zsz3","importantInfo":"styles_importantInfo__3fR5L"};